import { withTranslation } from "react-i18next";
import React, { Component } from "react";
import Footer from "../../../components/Footer";
import Carousel from "../components/Carousel";
import "../styles.css";
import { config } from "../../../config";
import BikeFitPromo from "../components/BikefitPromo";
import DocumentMeta from "react-document-meta";
import i18next from "i18next";
import Locale from "../../../lib/Locale";

class RaceHome extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.startSlider = this.startSlider.bind(this);
    this.moveRight = this.moveRight.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.startSlider();
    var self = this;
    setInterval(function () {
      self.moveRight();
    }, 1000);
  }
  render() {
    const meta = {
      title: this.props.t("RaceHome_FindBike"),
      description: this.props.t("RaceHome_Questions"),
    };

    return (
      <div>
        <DocumentMeta {...meta} />
        <div className="jumbotron-fluid">
          <div className="container-fluid">
            <h1>{this.props.t("RaceHome_FindBike")}</h1>
            <p className="lead sub">{this.props.t("RaceHome_Questions")}</p>
            <div className="my-4">&nbsp;</div>
            <p className="lead">
              <a
                className="btn btn-primary btn-lg"
                href={Locale.getUrlForCurrentLocale("/road/advice/experience")}
                role="button"
              >
                {this.props.t("RaceHome_StartAdvice")}
              </a>
              <button className="btn btn-lg btn-default to_info">
                {this.props.t("RaceHome_WhyAdvice")}
              </button>
            </p>
            <ul className="list-inline">
              <li className="list-inline-item">
                {this.props.t("RaceHome_PersonalAdvice")}
              </li>
              <li className="list-inline-item">
                {this.props.t("RaceHome_Compare")}
              </li>
              <li className="list-inline-item">
                {this.props.t("RaceHome_Transparent")}
              </li>
            </ul>
          </div>
        </div>
        <BikeFitPromo dark={false} />

        <div className="seo-intro-container py-4">
          <div className="container text-center">
            <h2>{this.props.t("Kopen van de juiste racefiets")}</h2>
            <p>
              {this.props.t(
                "InfoRacefietsen-Genieten van de natuur en tegelijkertijd"
              )}
            </p>
          </div>
        </div>

        <div className="container text-center">
          <div className="row justify-content-center align-items-center">
            <div id="framefit_info" className="col-sm-12 framefit_info">
              <header className="prime_title">
                <h2>{this.props.t("RaceHome_Personal")}</h2>
              </header>
            </div>
          </div>
          <div className="row justify-content-center align-items-center home-row">
            <div className="col-sm-6 align-middle">
              <h3>{this.props.t("RaceHome_CustomAdvice")}</h3>
              <p>{this.props.t("RaceHome_WeThink")}</p>
            </div>

            <div className="col-sm-6 text-center">
              <div className="home-column-inner">
                <img
                  className="img-responsive"
                  src={
                    i18next.language === "nl_NL"
                      ? "/img/silhouette/Racefiets-fietsmaat.png"
                      : "/img/silhouette/Road-bike-frame-size.png"
                  }
                  alt={this.props.t("Race_Size")}
                />
              </div>
            </div>
          </div>
          <div className="row justify-content-center align-items-center home-row">
            <div className="col-sm-6 order-12">
              <h3>{this.props.t("RaceHome_CompareBrands")}</h3>
              <p>{this.props.t("RaceHome_WeCompare")}</p>
            </div>
            <div className="col-sm-6 text-center order-1">
              <div className="home-column-inner slider">
                <Carousel type="race" />
              </div>
            </div>
          </div>
          <div className="row justify-content-center align-items-center home-row">
            <div className="col-sm-6">
              <h3>{this.props.t("RaceHome_TopThree")}</h3>
              <p>{this.props.t("RaceHome_WeGiveAdvice")}</p>
            </div>

            <div className="col-sm-6 text-center">
              <div className="home-column-inner">
                <img
                  className="img-responsive"
                  src={
                    i18next.language === "nl_NL"
                      ? "/img/Racefietsen-vergelijken-voorbeeld.png"
                      : "/img/Road-bike-comparison-example.png"
                  }
                  alt={this.props.t("RACE_Advies")}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="framefit_info">
          <div className="dark-section">
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <header className="prime_title">
                    <h2>{this.props.t("RaceHome_PrimeTitle")}</h2>
                  </header>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <h3>
                    {this.props.t("RaceHome_UserExperience")}
                    <i className="fas fa-caret-right"></i>
                  </h3>

                  <p>{this.props.t("RaceHome_RaceWithHelp")}.</p>
                </div>

                <div className="col-sm-4">
                  <h3>
                    {this.props.t("RaceHome_Size")}{" "}
                    <i className="fas fa-caret-right"></i>
                  </h3>

                  <p>{this.props.t("RaceHome_RaceBasedOn")}.</p>
                </div>

                <div className="col-sm-4">
                  <h3>{this.props.t("RaceHome_Advice")}</h3>

                  <p>{this.props.t("RaceHome_CompareTopThree")}</p>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-sm-3"></div>
                <div className="col-sm-6 text-center mt-5">
                  <video
                    controls
                    ref="vidRef"
                    poster="/img/poster-default.png"
                    src={
                      i18next.language === "nl_NL"
                        ? require("../video/Racefiets-kopen-advies.mp4")
                        : require("../video/Road-bike-buying-advice.mp4")
                    }
                    type="video/mp4"
                  ></video>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={
            i18next.language === "nl_NL"
              ? "section-new-race framefit_info"
              : "section-new-race-en framefit_info"
          }
        >
          <div className="container-fluid">
            <h3 className="display-4">{this.props.t("RaceHome_NoRaceBike")}</h3>
            <p className="sub">{this.props.t("RaceHome_AdviceBestFit")}</p>
            <hr className="my-2" />
            <p className="lead">
              <a
                className="btn btn-primary btn-lg"
                href={Locale.getUrlForCurrentLocale(config.mtbUrl + "/mtb/advice/experience")}
                role="button"
              >
                {this.props.t("RaceHome_StartAdviceMTB")}
              </a>
            </p>
          </div>
        </div>
        <div className="info-page ">
          <div className="container">
            <h2>
              {this.props.t(
                "Verschil van een racefiets ten opzichte van andere fietsen"
              )}
            </h2>

            <p>
              {this.props.t(
                "InfoRacefietsen-Een racefiets, ook wel wielrenfiets"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Tegenwoordig wordt een racefiets ook"
              )}
            </p>

            <p>
              {this.props.t("InfoRacefietsen-Om beter aan te sluiten op het")}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Een racefiets is in de eerste plaats"
              )}
            </p>

            <h2>{this.props.t("Een racefiets kopen")}</h2>

            <p>
              {this.props.t(
                "InfoRacefietsen-Een wielrenfiets kopen wordt door"
              )}
            </p>

            <p>
              {this.props.t("InfoRacefietsen-Het begint met de vraag wat je")}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Voor al deze doeleinden zal je op zoek"
              )}
            </p>

            <h2>
              {this.props.t("Wat is belangrijk voor een goede racefiets?")}
            </h2>

            <p>
              {this.props.t("InfoRacefietsen-Zoals eerder aangegeven is het")}
            </p>

            <h2>{this.props.t("Type racefiets")}</h2>

            <p>
              {this.props.t(
                "InfoRacefietsen-Het eerste en belangrijkste kenmerk van"
              )}
            </p>

            <h3>{this.props.t("Aero racefiets")}</h3>

            <p>
              {this.props.t(
                "InfoRacefietsen-Aero is een afkorting voor aerodynamisch"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Aerodynamische racefietsen zijn gemaakt"
              )}
            </p>

            <h3>{this.props.t("Endurance racefiets")}</h3>

            <p>
              {this.props.t(
                "InfoRacefietsen-Als je vooral op zoek bent naar rijcomfort"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Sommige endurance modellen bieden extra"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Veel moderne endurance fietsen zijn voorzien"
              )}
            </p>

            <h3>{this.props.t("Allround racefiets")}</h3>

            <p>
              {this.props.t(
                "InfoRacefietsen-De allround/normale racefiets zit"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-De duurdere normale racefietsen zijn vaak"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-De geometrie en fietshouding van allround"
              )}
            </p>

            <h3>{this.props.t("Gravel racefiets")}</h3>

            <p>
              {this.props.t(
                "InfoRacefietsen-Een gravel racefiets of gravel bike"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Met bredere banden kun je kiezen voor"
              )}
            </p>

            <h2>{this.props.t("Frame materiaal")}</h2>

            <p>
              {this.props.t(
                "InfoRacefietsen-Een wielrenfiets wordt gemaakt uit"
              )}
            </p>

            <h3>{this.props.t("Carbon")}</h3>

            <p>
              {this.props.t(
                "InfoRacefietsen-Carbon is het meest gebruikte materiaal"
              )}
            </p>

            <p>
              {this.props.t("InfoRacefietsen-Een nadeel van carbon is dat het")}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Voor een carbon fiets betaal je meestal"
              )}
            </p>

            <h3>{this.props.t("Aluminium")}</h3>

            <p>
              {this.props.t(
                "InfoRacefietsen-Een van de veelgebruikte materialen voor"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Er wordt bij aluminium vaak gebruikt gemaakt"
              )}
            </p>

            <h3>{this.props.t("Staal")}</h3>

            <p>
              {this.props.t(
                "InfoRacefietsen-Als je een echte retroliefhebber bent"
              )}
            </p>

            <h3>{this.props.t("Titanium")}</h3>

            <p>
              {this.props.t(
                "InfoRacefietsen-Een titanium racefiets kan in principe"
              )}
            </p>

            <h2>{this.props.t("Afmontage van de racefiets")}</h2>

            <p>
              {this.props.t(
                "InfoRacefietsen-De kwaliteit van de afmontage van"
              )}
            </p>

            <h3>{this.props.t("Wielen")}</h3>

            <p>
              {this.props.t(
                "InfoRacefietsen-De wielen kunnen een groot verschil"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-De velgen kunnen verschillende breedtes"
              )}
            </p>

            <p>{this.props.t("InfoRacefietsen-Carbon wielen zijn lichter")}</p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Het is ook belangrijk om te kijken"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Tubes worden vooral door wedstrijdrijders"
              )}
            </p>

            <h3>{this.props.t("Groepset")}</h3>

            <p>
              {this.props.t("InfoRacefietsen-Een groepset van een racefiets")}
            </p>

            <h3>{this.props.t("Aantal versnellingen")}</h3>

            <p>
              {this.props.t(
                "InfoRacefietsen-Bij de versnellingen van een racefiets"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Fiets je alleen in een vlakke omgeving"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-De meeste racefietsen hebben tegenwoordig"
              )}
            </p>

            <h2>{this.props.t("Prijs")}</h2>

            <p>
              {this.props.t(
                "InfoRacefietsen-Niet onbelangrijk om bij stil te staan"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-De volgende opties bepalen in belangrijke"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Er zijn echter ook voldoende goede"
              )}
            </p>

            <h2>{this.props.t("Verschil heren- en damesfietsen")}</h2>

            <p>
              {this.props.t(
                "InfoRacefietsen-De laatste jaren is het aantal dames"
              )}
            </p>

            <p>
              {this.props.t("InfoRacefietsen-Sommige merken claimen ook dat")}
            </p>

            <h2>{this.props.t("Goede fietshouding")}</h2>

            <p>
              {this.props.t(
                "InfoRacefietsen-Een goede fietshouding en fietsafstelling"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Als je van plan bent om een nieuw"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-In ons Bikefit advies stellen wij diverse"
              )}
            </p>

            <h3>{this.props.t("Maat racefiets")}</h3>

            <p>
              {this.props.t(
                "InfoRacefietsen-Voor een optimale fietservaring is het"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-In de fietsbranche wordt vaak een framemaat"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Twee personen van dezelfde lengte kunnen"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Een framemaat is gebaseerd op de zitbuis"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-De reach is de horizontale afstand van het"
              )}
            </p>

            <p>
              {this.props.t("InfoRacefietsen-De stack is de verticale afstand")}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Het kiezen van de juiste framemaat en"
              )}
            </p>

            <h3>{this.props.t("Finetunen van de fietsafstelling")}</h3>

            <p>
              {this.props.t("InfoRacefietsen-Tijd om de knoop door te hakken")}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-De Framefit bikefit is echter een modelberekening"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Start hierbij bij de voeten en ga stap"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-In de bijlage bij ons Bikefit advies staat"
              )}
            </p>

            <h3>{this.props.t("Schoenplaatjes")}</h3>

            <p>
              {this.props.t(
                "InfoRacefietsen-Als je schoenplaatjes niet goed aangebracht"
              )}
            </p>

            <h3>{this.props.t("Crank-lengte")}</h3>

            <p>
              {this.props.t(
                "InfoRacefietsen-De crank-lengte is niet meteen het eerste"
              )}
            </p>

            <h3>{this.props.t("Zadelhoogte en zadelbreedte")}</h3>

            <p>
              {this.props.t(
                "InfoRacefietsen-De zadel positie en vorm is een van de"
              )}
            </p>

            <h3>{this.props.t("Zadelhoek")}</h3>

            <p>
              {this.props.t(
                "InfoRacefietsen-Een optimale zadelhoek is erg persoonlijk"
              )}
            </p>

            <h3>{this.props.t("Zadel-setback")}</h3>

            <p>
              {this.props.t(
                "InfoRacefietsen-De zadel set-back stel je in door de zadelrails"
              )}
            </p>

            <h3>{this.props.t("Zitlengte en drop")}</h3>

            <p>
              {this.props.t(
                "InfoRacefietsen-Met de zitlengte en drop wordt de positie"
              )}
            </p>

            <h2>{this.props.t("Andere optie")}</h2>

            <p>
              {this.props.t(
                "InfoRacefietsen-Als je toch (nog) te veel twijfelt"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoRacefietsen-Hopelijk heeft dit je wat inzicht"
              )}
            </p>
          </div>
        </div>

        <Footer t={this.props.t} />
      </div>
    );
  }

  startSlider() {
    var slideCount = window.$("#slider ul li").length;
    var slideWidth = window.$("#slider ul li").width() * 2 + 75;
    var slideHeight = window.$("#slider ul li").height();
    var sliderUlWidth = slideCount * slideWidth;

    window.$("#slider").css({ height: slideHeight });

    window
      .$("#slider ul")
      .css({ width: sliderUlWidth, marginLeft: -slideWidth });

    window.$("#slider ul li:last-child").prependTo("#slider ul");
  }

  moveRight() {
    var slideWidth = window.$("#slider ul li").width();
    window.$("#slider ul").animate(
      {
        left: -slideWidth,
      },
      1000,
      function () {
        window.$("#slider ul li:first-child").appendTo("#slider ul");
        //window.$('#slider ul').css('left', '');
      }
    );
  }
}

export default withTranslation("homeRace")(RaceHome);
